<loader *ngIf="downloadingFile"></loader>

<!-- <iframe
  *ngIf="!downloadingFile && iframeUrl"
  [src]="iframeUrl"
  frameborder="0"
></iframe> -->
